export function isNewSmartflyerMenuEnabled(flag = process.env.NEXT_PUBLIC_NEW_SMARTFLYER_MENU): boolean {
  return flag === 'true';
}

type ContentMenuLink = {
  title: string;
  href: string;
};

type ContentMenuGroup = {
  title: string;
  href: string;
  nestedLink: ContentMenuLink[];
};

export function buildContentMenuGroups(input: {
  society: ContentMenuLink[];
  smartflyer: ContentMenuLink[];
  newSmartflyer: ContentMenuLink[];
}): ContentMenuGroup[] {
  return [
    ...(input.society.length > 0 ? [{ title: 'Society CRM', href: '#', nestedLink: input.society }] : []),
    ...(input.smartflyer.length > 0 ? [{ title: 'SmartFlyer.com', href: '#', nestedLink: input.smartflyer }] : []),
    ...(input.newSmartflyer.length > 0
      ? [{ title: 'NEW SmartFlyer.com', href: '#', nestedLink: input.newSmartflyer }]
      : []),
  ];
}
